import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { SessionFormItem } from '@components/Clinicians/Session/Components/SessionFormItem';
import { useSessionFormState } from '@hooks/useSessionFormState';
import { useSessionAction } from '@hooks/useSessionAction';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { type ApptActionCodes } from 'vl-common/src/schemas/getMetaAppointments';
import useAppointmentMeta from '@components/Clinicians/Session/hooks/useAppointmentMeta';

export const CallTypeFormItem = ({
  onChange = () => {},
  actionCode
}: {
  onChange?: (value: string) => void;
  actionCode: ApptActionCodes;
}) => {
  const { t } = useTranslation('common');
  const { data: appointmentMeta } = useAppointmentMeta();
  const { CALL_TYPE_KEY } = useSessionAction(actionCode);
  const {
    appointment: { appointment_completed: isCompleted, read_only: readonly }
  } = useSessionAppointment();

  const [callType, setCallType] = useSessionFormState(CALL_TYPE_KEY);

  const callTypeOptions = useMemo(() => {
    return (
      appointmentMeta?.call_types?.map((type) => ({
        value: type.call_type_code,
        label: type.call_type_desc
      })) || []
    );
  }, [appointmentMeta]);

  return (
    <SessionFormItem label={t('Choose a call type')} name={CALL_TYPE_KEY} data-testid="call-type-form-item">
      <Select
        disabled={isCompleted || readonly}
        placeholder={t('Select from dropdown')}
        value={callType}
        onSelect={(value) => {
          setCallType(value);
          onChange(value);
        }}
        data-testid="call-type-select"
        options={callTypeOptions || []}
      />
    </SessionFormItem>
  );
};
